import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';

var NoticeTips = function (_super) {
  __extends(NoticeTips, _super);

  function NoticeTips() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.visible = false;
    return _this;
  }

  NoticeTips.prototype.handle = function () {
    this.visible = false;
  };

  NoticeTips = __decorate([Component], NoticeTips);
  return NoticeTips;
}(Vue);

export default NoticeTips;